/**
 * Faster collection/product browsing: prefetch PDPs, lightweight ATC (no drawer flash).
 */
(function () {
  const prefetched = new Set();

  function prefetchUrl(url) {
    if (!url || prefetched.has(url)) return;
    prefetched.add(url);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = url;
    document.head.appendChild(link);
  }

  function getProductHref(el) {
    const anchor = el.closest('a[href*="/products/"]');
    if (!anchor || anchor.target === '_blank') return null;
    try {
      return new URL(anchor.href, window.location.origin).href;
    } catch (e) {
      return null;
    }
  }

  document.addEventListener(
    'touchstart',
    (e) => {
      const href = getProductHref(e.target);
      if (href) prefetchUrl(href);
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'mouseover',
    (e) => {
      const href = getProductHref(e.target);
      if (href) prefetchUrl(href);
    },
    { passive: true }
  );

  let toastTimer;
  window.capshapShowCartToast = function () {
    let toast = document.getElementById('capshap-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'capshap-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML =
        '<span>Added to cart</span><button type="button" class="capshap-cart-toast__view">View cart</button>';
      document.body.appendChild(toast);
      toast.querySelector('.capshap-cart-toast__view').addEventListener('click', () => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        toast.classList.remove('is-visible');
      });
    }
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  };

  window.capshapIsBrowseShopping = function () {
    const body = document.body;
    if (!body) return false;
    if (body.classList.contains('template-collection') || body.classList.contains('template-product')) {
      return true;
    }
    return !!document.querySelector('#product-grid, .product-grid, .collection');
  };
})();
